/*
  The one place the first-week guide's step titles live. The dashboard guide
  shows them and the lifecycle emails name them, so an email and the screen
  it links to say the same thing. No em dashes.
*/
export const FIRST_WEEK_STEP_TITLES = {
    add_site: 'Add your site',
    profile: 'Confirm your business profile',
    hubspot: 'Connect HubSpot',
    invite: 'Invite the person who runs your site',
    first_page: 'Set up your first page',
    live: 'See it live on your site',
    pixel: 'Install the bot pixel',
    watch: 'Watch this page',
    report: 'See your report',
    free_page: 'Put your first page live',
};
